import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export class WorkoutRuns extends Vue {

  @Prop({ required: true })
  runs: number

  render (h: CreateElement) {
    const label = this.$tc('PAGE.CLUB.CLUB_STATISTICS.STATION_WORKOUTS_RUNS', this.runs)
    return <div class='workout-runs' aria-label={`${this.runs} ${label}`}>
      <span class='workout-runs-count' aria-hidden='true'>{this.runs}</span>
      <span class='workout-runs-label' aria-hidden='true'>{label}</span>
    </div>
  }
}
